import { bubble as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChecklistIcon from "@mui/icons-material/Checklist";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import InfoIcon from "@mui/icons-material/Info";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import FeedbackIcon from "@mui/icons-material/Feedback";
import useWindowDimensions from "../../helpers/window";

const MenuSection = ({ title, children }) => (
  <div className="burger-menu-section">
    <Typography
      variant="menuSectionTitle"
      className="burger-menu-section-title"
    >
      {title}
    </Typography>
    {children}
  </div>
);

const MenuItem = ({ to, icon: Icon, label }) => (
  <Link to={to} className="burger-menu-item">
    <Icon className="burger-menu-item-icon" />
    <Typography variant="menuItemNoMargin" className="burger-menu-item-text">
      {label}
    </Typography>
  </Link>
);

const BurgerMenu = () => {
  const user = useSelector((state) => state.user.activeUser);
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  return (
    <Menu>
      <MenuSection title="Navigate">
        {!isMobile && <MenuItem to="/" icon={HomeIcon} label="Home" />}
        <MenuItem to="/dashboard" icon={DashboardIcon} label="Dashboard" />
        <MenuItem to="/tasks" icon={ChecklistIcon} label="Tasks" />
        <MenuItem to="/planner" icon={CalendarTodayIcon} label="Day Planner" />
        <MenuItem
          to="/activities"
          icon={SelfImprovementIcon}
          label="Activities"
        />
      </MenuSection>

      <MenuSection title="Information">
        <MenuItem
          to="/about/what-is-mindstack"
          icon={InfoIcon}
          label="How to use"
        />
        <MenuItem to="/privacy" icon={PrivacyTipIcon} label="Privacy Policy" />
      </MenuSection>

      {user && (
        <>
          <MenuSection title="Account">
            <MenuItem to="/feedback" icon={FeedbackIcon} label="Feedback" />
          </MenuSection>
        </>
      )}
    </Menu>
  );
};

export default BurgerMenu;
